import React, { useEffect, useState, useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Box,
  Link,
} from "@material-ui/core";
import UseStyles from "./UseStyles";
import Moment from "moment";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import { GuarantorsDataAPI } from "../../API/GuarantorsDataAPI";
import NmefSpinner from "../../NmefSpinner";
import GuarantorEdit from "./GuarantorEdit/GuarantorEdit";
import { checkEditAccess } from "../../Constants/utils";
import AppContext from "../../DocsFunding/ContextCreation/AppContext";

const Guarantor = ({
  guarantorData,
  originalGuarantors,
  isReadOnly,
  brokerId,
  addNew,
  setAddGuarantor,
  lessee,
  app,
  setGuarantorDataList,
  usStates
}) => {
  const classes = UseStyles();
  const [guarantors, setGuarantors] = useState(
    originalGuarantors ? [...originalGuarantors] : []
  );
  const [spinner, setSpinner] = useState(false);
  const [editVR, setEditVR] = useState(false);
  const [editGuarantorData, setEditGuarantorData] = useState({});
  const [editGuarantorFlag, setEditGuarantorFlag] = useState(false);
  const { setGuarantorData } = useContext(AppContext);

  const saveVerbalRequired = async () => {
    setSpinner(true);
    await updateGuarantorsAPI();
    setEditVR(false);
    setSpinner(false);
  };
  const handleVerbalReq = () => {
    if (editVR) resetGuarantors();
    setEditVR(!editVR);
  };

  const updateGuarantorsAPI = async () => {
    try {
      for (let index = 0; index < guarantors.length; index++) {
        await GuarantorsDataAPI.putRequestGuarantor(guarantors[index].guarantor);
      }
      await GuarantorsDataAPI.updateGuarantor(guarantors, brokerId, app.locked_by_email);
    }
    catch (err) {
      console.error("Save Primary signer", err);
    }
    finally {
      let appGuars = await GuarantorsDataAPI.getGuarantorsByAppId(
        app?.id,
        app?.broker_id,
        app?.locked_by_email
      );
      setGuarantorData(appGuars);
    }
  };
  useEffect(() => {
    if (addNew && !editGuarantorFlag) {
      setEditGuarantorFlag(!editGuarantorFlag);
      setEditGuarantorData({});
    }
  }, [addNew, editGuarantorFlag]);

  useEffect(() => {
    setGuarantors(originalGuarantors);
  }, [originalGuarantors]);

  const changeVerbReq = (guarObj, verReq) => {
    let updatedGuarantors = guarantors?.map((guar) => {
      if (guar.id === guarObj.id) {
        return {
          ...guar,
          guarantor: {
            ...guar.guarantor,
            require_verbal_DNA: verReq,
          },
          // require_verbal_DNA: verReq,
        };
      } else return guar;
    });
    setGuarantors(updatedGuarantors);
  };

  const updateEditedGuarantors = (guarObj) => {
    let updatedGuarantors = guarantors?.map((guar) => {
      if (guar.id === guarObj.id) {
        return guarObj;
      } else return guar;
    });
    setGuarantors(updatedGuarantors);
  };

  const resetGuarantors = () => {
    setGuarantors(originalGuarantors);
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.header_bold} align="left">
                Name
              </TableCell>
              {originalGuarantors ? (
                isReadOnly ? (
                  <TableCell className={classes.header_bold} align="left">
                    Primary Signer
                  </TableCell>
                ) : (
                  <TableCell className={classes.header_bold} align="left">
                    <Box component="div" style={{ display: "flex" }}>
                      Primary Signer
                      {editVR ? (
                        <Box>
                          <SaveIcon
                            style={{
                              color: "green",
                              cursor: "pointer",
                            }}
                            onClick={saveVerbalRequired}
                          />
                          <CancelPresentationIcon
                            style={{
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={handleVerbalReq}
                          />
                        </Box>
                      ) : (
                        <EditIcon
                          style={{
                            cursor: "pointer",
                            marginLeft: "2px",
                          }}
                          onClick={handleVerbalReq}
                        />
                      )}
                    </Box>
                  </TableCell>
                )
              ) : null}
              <TableCell className={classes.header_bold} align="center">
                Ownership
              </TableCell>
              <TableCell className={classes.header_bold} align="left">
                SSN/FEIN
              </TableCell>
              <TableCell className={classes.header_bold} align="left">
                Date of Birth
              </TableCell>
              <TableCell className={classes.header_bold} align="left">
                Phone
              </TableCell>
              <TableCell className={classes.header_bold} align="left">
                Marital Status
              </TableCell>
              <TableCell className={classes.header_bold} align="left">
                Address
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {spinner ? (
              <NmefSpinner />
            ) : (
              guarantorData.map((row, i) => (
                <TableRow key={i}>
                  <TableCell align="left">
                    {!isReadOnly && checkEditAccess() ? (
                      <Link
                        component="button"
                        variant="body2"
                        style={{ color: "#3f51b5" }}
                        onClick={() => {
                          setEditGuarantorFlag(!editGuarantorFlag);
                          setEditGuarantorData(guarantors[i]);
                        }}>
                        {row.name}
                      </Link>
                    ) : (
                      row.name
                    )}
                  </TableCell>
                  {originalGuarantors ?
                    (<TableCell align="left">
                      {editVR ? (
                        <>
                          {(guarantors[i]?.guarantor_type === "Personal") ? (
                            <Checkbox
                              color="primary"
                              checked={guarantors[i]?.guarantor?.require_verbal_DNA}
                              onChange={(e) => changeVerbReq(guarantors[i], e.target.checked)}
                            />
                          ) : (
                            <CancelPresentationIcon
                              style={{
                                marginLeft: "10px",
                                color: "red",
                              }}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {guarantors[i]?.guarantor?.require_verbal_DNA ? (
                            <CheckBoxOutlinedIcon
                              fontSize="medium"
                              style={{
                                color: "green",
                              }}
                            />
                          ) : (
                            <CancelPresentationIcon
                              style={{
                                color: "red",
                              }}
                            />
                          )}
                        </>
                      )}
                    </TableCell>
                    ) : null}
                  <TableCell align="center">{row.Percent_of_Ownership ? `${row.Percent_of_Ownership}%` : "0%"}</TableCell>
                  <TableCell align="left">{row.SSN_FEIN}</TableCell>
                  <TableCell align="left">
                    {row.Date_of_Birth
                      ? row.Date_of_Birth === "N/A"
                        ? "N/A"
                        : Moment(row.Date_of_Birth).format("MM/DD/YYYY")
                      : ""}
                  </TableCell>
                  <TableCell align="left">{row.Phone}</TableCell>
                  <TableCell align="left">{row.Marital_Status}</TableCell>
                  <TableCell align="left">
                    <p>{row.Address}</p>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {isReadOnly ? null : (
        <GuarantorEdit
          editGuarantorFlag={editGuarantorFlag}
          setEditGuarantorFlag={setEditGuarantorFlag}
          guarantor={editGuarantorData}
          updateEditedGuarantors={updateEditedGuarantors}
          guarantors={guarantors}
          setGuarantors={setGuarantors}
          brokerId={brokerId}
          setAddGuarantor={setAddGuarantor}
          lessee={lessee}
          app={app}
          setGuarantorDataList={setGuarantorDataList}
          usStates={usStates}
        />
      )}
    </div>
  );
};
export default Guarantor;
